// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { cleaningProcedureId } from './CleaningProcedure';
import { cleaningFormId } from './CleaningForm';
import { operatorId } from './Operator';
import { z } from 'zod';
export const cleaningRecordId = (z.number());
export const cleaningRecord = z.object({
    id: cleaningRecordId,
    procedure_id: cleaningProcedureId,
    form_id: cleaningFormId,
    performed_at: z.date().nullable(),
    performed_by: operatorId.nullable(),
    completed_at: z.date().nullable(),
    notes: z.string().nullable(),
    created_at: z.date(),
    updated_at: z.date(),
    created_by: operatorId.nullable(),
    last_updated_by: operatorId.nullable(),
    deleted_at: z.date().nullable(),
    deleted_by: operatorId.nullable(),
});
export const cleaningRecordInitializer = z.object({
    id: cleaningRecordId.optional(),
    procedure_id: cleaningProcedureId,
    form_id: cleaningFormId,
    performed_at: z.date().optional().nullable(),
    performed_by: operatorId.optional().nullable(),
    completed_at: z.date().optional().nullable(),
    notes: z.string().optional().nullable(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
    created_by: operatorId.optional().nullable(),
    last_updated_by: operatorId.optional().nullable(),
    deleted_at: z.date().optional().nullable(),
    deleted_by: operatorId.optional().nullable(),
});
export const cleaningRecordMutator = z.object({
    id: cleaningRecordId.optional(),
    procedure_id: cleaningProcedureId.optional(),
    form_id: cleaningFormId.optional(),
    performed_at: z.date().optional().nullable(),
    performed_by: operatorId.optional().nullable(),
    completed_at: z.date().optional().nullable(),
    notes: z.string().optional().nullable(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
    created_by: operatorId.optional().nullable(),
    last_updated_by: operatorId.optional().nullable(),
    deleted_at: z.date().optional().nullable(),
    deleted_by: operatorId.optional().nullable(),
});
//# sourceMappingURL=CleaningRecord.js.map